import { initialPopup } from 'hooks/constants'
import { PopupReturnTypeWithPayload } from 'hooks/usePopup'

export type GenerateResolutionLinkPopupPayload = {
  uuid?: string
}

export type ResolutionLinkGeneratedPopupPayload = {
  link?: string
  expires_on?: string
}

export const generateResolutionLinkPopupWithPayload: PopupReturnTypeWithPayload<GenerateResolutionLinkPopupPayload> =
  {
    state: {
      ...initialPopup?.state,
      payload: {
        uuid: ''
      }
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }

export const resolutionLinkGeneratedPopupWithPayload: PopupReturnTypeWithPayload<ResolutionLinkGeneratedPopupPayload> =
  {
    state: {
      ...initialPopup?.state,
      payload: {
        link: '',
        expires_on: ''
      }
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }
